import cn from 'classnames';
import type React from 'react';

import * as st from './styles.module.scss';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	dayValue: number;
	isSelected: boolean;
	notPassed?: boolean;
	finishDay?: boolean;
}

const DayButton: React.FC<Props> = ({ dayValue, isSelected, notPassed, finishDay, ...props }) => {
	return (
		<button className={cn(st.btn, notPassed && st.notPassed, isSelected && st.selected, finishDay && st.finishDay)} {...props}>
			{dayValue}
		</button>
	);
};

export default DayButton;
